export const GAME_CONFIG = {
  canvas: {
    width: 540,
    height: 960,
  },
  world: {
    groundY: 780,
    gravity: 1800,
    backgroundSpeedRatio: 1,
    lanePadding: 60,
  },
  player: {
    x: 188,
    defaultRunner: 'male',
    runnerIds: ['male', 'female'],
    width: 118,
    height: 118,
    fallWidth: 168,
    fallHeight: 118,
    jumpVelocity: -780,
    doubleJumpVelocity: -720,
    stompBounceVelocity: -500,
    coyoteTime: 0.08,
    maxAirJumps: 1,
    frameDuration: 0.07,
    fallFrameDuration: 0.16,
    runFrames: [0, 1, 2, 3, 4, 5],
    jumpFrames: 4,
    fallFrames: 6,
    collisionInset: {
      x: 30,
      y: 22,
    },
  },
  bull: {
    x: -112,
    y: 674,
    width: 218,
    height: 164,
    frameDuration: 0.1,
    dodgeDuration: 0.42,
  },
  gameOver: {
    caughtDuration: 0.95,
    caughtSpeedRatio: 1.15,
    playerKnockbackX: -132,
    playerKnockbackY: 12,
    playerTripLiftY: 36,
  },
  obstacles: {
    spawnX: 620,
    initialSpawnX: 1040,
    despawnX: -180,
    minGap: 240,
    maxInitialBatch: 3,
    frameDuration: 0.11,
    bullFrameDuration: 0.16,
    types: [
      {
        id: 'crate',
        width: 114,
        height: 104,
        frame: 0,
        groundOffset: 4,
        stompable: true,
        points: 1,
      },
      {
        id: 'barrel',
        width: 104,
        height: 126,
        frame: 1,
        groundOffset: 2,
        stompable: true,
        points: 1,
      },
      {
        id: 'festivalBarricade',
        width: 166,
        height: 116,
        frame: 2,
        groundOffset: 5,
        stompable: false,
        points: 1,
        collisionInset: {
          x: 0.08,
          y: 0.18,
          width: 0.84,
          height: 0.66,
        },
      },
      {
        id: 'sacks',
        width: 146,
        height: 96,
        frame: 3,
        groundOffset: 8,
        stompable: true,
        points: 1,
      },
      {
        id: 'boxes',
        width: 132,
        height: 130,
        frame: 4,
        groundOffset: 4,
        stompable: true,
        points: 1,
      },
      {
        id: 'fallenRunner',
        width: 166,
        height: 76,
        frame: 5,
        groundOffset: 12,
        stompable: false,
        points: 1,
        shadowScale: 0.58,
        collisionInset: {
          x: 0.08,
          y: 0.28,
          width: 0.84,
          height: 0.5,
        },
      },
      {
        id: 'bull',
        y: 674,
        width: 218,
        height: 164,
        animated: true,
        sprite: 'bull',
        stompable: false,
        points: 3,
        collisionInset: {
          x: 0.23,
          y: 0.26,
          width: 0.54,
          height: 0.58,
        },
      },
    ],
  },
  difficulty: {
    easy: {
      startSpeed: 190,
      speedRamp: 5,
      startSpawnDelay: 2.65,
      minSpawnDelay: 1.28,
      initialObstacles: 1,
    },
    normal: {
      startSpeed: 245,
      speedRamp: 8,
      startSpawnDelay: 2.1,
      minSpawnDelay: 1.04,
      initialObstacles: 1,
    },
    hard: {
      startSpeed: 330,
      speedRamp: 13,
      startSpawnDelay: 1.52,
      minSpawnDelay: 0.74,
      initialObstacles: 2,
    },
  },
  storage: {
    bestTimeKey: 'sanfermin-runner:best-time',
    bestTimeByDifficultyKey: 'sanfermin-runner:best-time-by-difficulty',
    languageKey: 'sanfermin-runner:language',
    runnerKey: 'sanfermin-runner:selected-runner',
    scoresKey: 'sanfermin-runner:scores-by-difficulty',
  },
};
